export default "__VITE_ASSET__7l1A8S1Z__"